/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_f1_budget_locked_aria = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Locked — watch an ad or go Pro`)
};

const es_f1_budget_locked_aria = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bloqueado — mira un anuncio o hazte Pro`)
};

const de_f1_budget_locked_aria = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gesperrt — Werbung ansehen oder Pro werden`)
};

const nl_f1_budget_locked_aria = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vergrendeld — bekijk een advertentie of ga Pro`)
};

const fr_f1_budget_locked_aria = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verrouillé — regardez une pub ou passez Pro`)
};

const it_f1_budget_locked_aria = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bloccato — guarda una pubblicità o passa a Pro`)
};

const pt_br2_f1_budget_locked_aria = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bloqueado — assista a um anúncio ou vá Pro`)
};

const pt_f1_budget_locked_aria = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bloqueado — assista a um anúncio ou torne-se Pro`)
};

const ja_f1_budget_locked_aria = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ロック中 — 広告を見るかProにアップグレード`)
};

const zh_f1_budget_locked_aria = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`已锁定 — 观看广告或升级Pro`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const f1_budget_locked_aria = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.f1_budget_locked_aria(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("f1_budget_locked_aria", locale)
	if (locale === "en") return en_f1_budget_locked_aria(inputs)
	if (locale === "es") return es_f1_budget_locked_aria(inputs)
	if (locale === "de") return de_f1_budget_locked_aria(inputs)
	if (locale === "nl") return nl_f1_budget_locked_aria(inputs)
	if (locale === "fr") return fr_f1_budget_locked_aria(inputs)
	if (locale === "it") return it_f1_budget_locked_aria(inputs)
	if (locale === "pt-BR") return pt_br2_f1_budget_locked_aria(inputs)
	if (locale === "pt") return pt_f1_budget_locked_aria(inputs)
	if (locale === "ja") return ja_f1_budget_locked_aria(inputs)
	return zh_f1_budget_locked_aria(inputs)
};